import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Store actions/selectors
import { adminOrderListSelector } from 'store/Admin/OrderList';
import {
  fetchAdminOrderDisplay,
  fetchAdminTextOrderDisplay,
  fetchAdminOrderLineDisplay,
} from 'store/Admin/OrderDisplay/features';
import { setStatus } from 'store/Admin/OrderDisplay';
import { setOrderId, setOrderType } from 'store/Admin/Analyser';
import { adminClientOrderListSelector } from 'store/AdminClient/OrderList';
import {
  fetchadminCLientOrderDisplay,
  fetchadminCLientOrderLineDisplay,
  fetchAdminClientTextOrderDisplay,
} from 'store/AdminClient/OrderDisplay/features';
// Hooks & utils
import { ORDERSTATUS } from 'utils/Constants';

// UI Components
import OrdersTable from 'components/shared/OrdersTable';

import './order.css';
import ProjectTable from 'components/shared/ProjectTable';

export default function SmartWithReviewProjects() {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const { smartWithReviewOrders, isLoading, isError } = useSelector(
    adminClientOrderListSelector
  );

  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));
  }, []);

  return (
    <ProjectTable
      title={t('Projets smart avec révision')}
      orderStatus={ORDERSTATUS.SMART_WITH_REVIEW}
      orders={smartWithReviewOrders}
      isLoading={isLoading}
      isError={isError}
      fetchDisplayData={(id, orderType) => {
        dispatch(setStatus(ORDERSTATUS.SMART_WITH_REVIEW));
        dispatch(setOrderId(id));
        dispatch(setOrderType(orderType));
        dispatch(fetchadminCLientOrderDisplay(id));
        dispatch(fetchadminCLientOrderLineDisplay(id));
        dispatch(fetchAdminClientTextOrderDisplay(id));
      }}
      onRowClickRedirectPath="/AdminClient/DetailsProject"
    />
  );
}
